import React from 'react';
import Container from "../../Wrappers/Container";
import FormInput from "../../Atoms/Templates/FormInput";
import PasswordInput from "../../Atoms/Forms/PasswordInput";

const ProfileForm = () => {
  return (
    <Container>
      <form action="#"
        className="ed-grid rows-gap s-gap-4 s-mb-0">
        <section className="s-mb-0">
          <h3>Datos básicos</h3>
          <div className="ed-grid m-grid-2 rows-gap s-gap-2 m-gap-4">
            <FormInput label="Nombre completo"
              value="Evelyn Castrejón Jiménez"
              isRequired/>
            <FormInput label="Correo electrónico"
              type="email"
              value="eveleyn-cas@discord.com"
              isRequired/>
          </div>
        </section>

        <section className="s-mb-0">
          <h3 className="s-mb-8px">Seguridad</h3>
          <p className="s-mb-16px small">Llena estos datos sólo si quieres cambiar de contraseña</p>
          <div className="ed-grid m-grid-2 rows-gap s-gap-2 m-gap-4">
            <PasswordInput label="Contraseña actual"/>
            <PasswordInput label="Nueva contraseña"/>
          </div>
        </section>

        <div className="buttons-container">
          <button className="button cancel">Cancelar</button>
          <button className="button">Actualiza la información</button>
        </div>
      </form>
    </Container>
  );
};

export default ProfileForm;
